import createCache from 'services/createCache';

export default createCache({
	contactsMap: {
		map: null,
		buildingsLayer: null,
		mapLayer: null,
	},
});
